import { TableColumn } from '@bn/web-ui/table';

export const tableColumns: TableColumn[] = [
  {
    id: 'toggle',
    name: '',
    width: 50,
  },
  {
    id: 'endpoint',
    name: 'Endpoint',
    width: 90,
  },
  {
    id: 'url',
    name: '',
  },
  {
    id: 'schema',
    name: 'Schema',
  },
  {
    id: 'auth',
    name: 'Auth',
  },
  {
    id: 'rateLimiting',
    name: 'Rate Limiting',
  },
  {
    id: 'update',
    name: 'Last update',
  },
];
